import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { COLORS } from '../../theme';
import { userProfilePath } from '../../constants/userRoutes';

const montarItens = (userId) => [
  { id: 'perfil', label: 'Meu perfil', Icone: PersonRoundedIcon, path: userProfilePath(userId) },
  {
    id: 'configuracoes',
    label: 'Configurações',
    Icone: SettingsRoundedIcon,
    path: '/user/settings',
  },
  { id: 'ajuda', label: 'Ajuda', Icone: SupportAgentRoundedIcon, path: '/user/help' },
  {
    id: 'conhecimento',
    label: 'Base de conhecimento',
    Icone: MenuBookRoundedIcon,
    path: '/user/conhecimento',
  },
  { id: 'guia', label: 'Como usar a plataforma', Icone: HelpOutlineRoundedIcon, guia: true },
];

/**
 * Menu "⋯" do header mobile do cliente.
 *
 * Substitui a antiga faixa de pílulas (que duplicava a `UserBottomNav`) e
 * concentra o que a barra inferior não tem: perfil, ajustes, ajuda, base de
 * conhecimento, o guia da plataforma e sair.
 */
const UserHeaderMenu = ({ userId, onSair }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const aberto = Boolean(anchorEl);
  const itens = montarItens(userId);

  const fechar = () => setAnchorEl(null);

  const escolher = (item) => {
    fechar();

    if (item.guia) {
      window.dispatchEvent(new CustomEvent('zoompro:open-help'));
      return;
    }

    navigate(item.path);
  };

  return (
    <>
      <IconButton
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-label="Mais opções"
        aria-haspopup="menu"
        aria-expanded={aberto ? 'true' : 'false'}
        sx={{ color: COLORS.cream }}
      >
        <MoreVertRoundedIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={aberto}
        onClose={fechar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{ 'aria-label': 'Mais opções da área do cliente' }}
        PaperProps={{ sx: { minWidth: 240, borderRadius: '14px', mt: 0.8 } }}
      >
        {itens.map(({ id, label, Icone, ...item }) => (
          <MenuItem key={id} onClick={() => escolher({ id, label, Icone, ...item })}>
            <ListItemIcon sx={{ minWidth: 34, color: COLORS.orange }}>
              <Icone fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={label} primaryTypographyProps={{ fontSize: '0.9rem' }} />
          </MenuItem>
        ))}

        <Divider />

        <MenuItem
          onClick={() => {
            fechar();
            onSair?.();
          }}
        >
          <ListItemIcon sx={{ minWidth: 34, color: COLORS.orange }}>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Sair" primaryTypographyProps={{ fontSize: '0.9rem' }} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserHeaderMenu;
